import { TSubscriptionCouponsState } from "./subscriptionCoupons.types";

export const initialState: TSubscriptionCouponsState = {
  data: null,
  isLoading: false,
  error: null,
};
